export enum ActionTypes {
  // Informes horas
  GET_INFORMES_HORAS = 'gfm/informes/GET_INFORMES_HORAS',
  SET_INFORMES_HORAS = 'gfm/informes/SET_INFORMES_HORAS',
  GET_INFORMES_HORAS_COUNT = 'gfm/informes/GET_INFORMES_HORAS_COUNT',
  SET_INFORMES_HORAS_COUNT = 'gfm/informes/SET_INFORMES_HORAS_COUNT',
  GET_INFORMES_HORAS_EXCEL = 'gfm/informes/GET_INFORMES_HORAS_EXCEL',

  // Informes horas instructor
  GET_INFORMES_HORAS_INSTRUCTOR = 'gfm/informes/GET_INFORMES_HORAS_INSTRUCTOR',
  SET_INFORMES_HORAS_INSTRUCTOR = 'gfm/informes/SET_INFORMES_HORAS_INSTRUCTOR',
  GET_INFORMES_HORAS_INSTRUCTOR_COUNT = 'gfm/informes/GET_INFORMES_HORAS_INSTRUCTOR_COUNT',
  SET_INFORMES_HORAS_INSTRUCTOR_COUNT = 'gfm/informes/SET_INFORMES_HORAS_INSTRUCTOR_COUNT',
  GET_INFORMES_HORAS_INSTRUCTOR_EXCEL = 'gfm/informes/GET_INFORMES_HORAS_INSTRUCTOR_EXCEL',

  // Informes Infraestructura
  GET_INFORMES_INFRAESTRUCTURA = 'gfm/informes/GET_INFORMES_INFRAESTRUCTURA',
  SET_INFORMES_INFRAESTRUCTURA = 'gfm/informes/SET_INFORMES_INFRAESTRUCTURA',
  GET_INFORMES_INFRAESTRUCTURA_COUNT = 'gfm/informes/GET_INFORMES_INFRAESTRUCTURA_COUNT',
  SET_INFORMES_INFRAESTRUCTURA_COUNT = 'gfm/informes/SET_INFORMES_INFRAESTRUCTURA_COUNT',
  GET_INFORMES_INFRAESTRUCTURA_EXCEL = 'gfm/informes/GET_INFORMES_INFRAESTRUCTURA_EXCEL',

  // Filtros
  GET_SOCIEDADES_INFORMES = 'gfm/informes/GET_SOCIEDADES',
  SET_SOCIEDADES_INFORMES = 'gfm/informes/SET_SOCIEDADES',

  GET_PROVINCIAS_INFORMES = 'gfm/informes/GET_PROVINCIAS',
  SET_PROVINCIAS_INFORMES = 'gfm/informes/SET_PROVINCIAS',

  GET_ESTADOS_INFORMES = 'gfm/informes/GET_ESTADOS',
  SET_ESTADOS_INFORMES = 'gfm/informes/SET_ESTADOS',

  GET_CURSOS_INFORMES = 'gfm/informes/GET_CURSOS',
  SET_CURSOS_INFORMES = 'gfm/informes/SET_CURSOS',

  GET_ALUMNOS_INFORMES = 'gfm/informes/GET_ALUMNOS',
  SET_ALUMNOS_INFORMES = 'gfm/informes/SET_ALUMNOS',

  REMOVE_FILTERS_INFORMES = 'gfm/informes/REMOVE_FILTERS',

  // Cache
  SET_ALL_INFORMES_CURSOS_FILTER = 'fgm/informes/SET_ALL_INFORMES_CURSOS_FILTER',
}
